import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/byot.module';
import { environment } from './environments/environment';
import { AbstractLogger } from '@amc-technology/davinci-api';

export function getBaseUrl(): string {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('logger-service-worker.js')
    .then(() => navigator.serviceWorker.ready)
    .then((registration) => {
      const worker = navigator.serviceWorker.controller ?? registration.active ?? null;
      AbstractLogger.setServiceWorker(worker);
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        AbstractLogger.setServiceWorker(navigator.serviceWorker.controller);
      });
    })
    .catch(() => {
      AbstractLogger.setServiceWorker(null);
    });
} else {
  AbstractLogger.setServiceWorker(null);
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.log(err);
  });
